import {
  AllowanceTypeApi,
  ContributionSettingApi,
  DeductionTypeApi,
  PayrollPeriodApi,
  PayrollScheduleApi,
  TaxBracketApi,
} from '../../models/payroll/payroll-config.model';
import {
  EmployeeDtrStatusApi,
  PayrollResultApi,
  PayrollRunApi,
  PayslipApi,
} from '../../models/payroll/payroll-run.model';
import { EmployeeDeductionApi } from '../../models/payroll/employee-deduction.model';

export interface IPayrollState {
  schedules: PayrollScheduleApi[];
  periods: PayrollPeriodApi[];
  runs: PayrollRunApi[];
  selectedRun: PayrollRunApi | null;
  results: PayrollResultApi[];
  payslips: PayslipApi[];
  allowanceTypes: AllowanceTypeApi[];
  deductionTypes: DeductionTypeApi[];
  contributionSettings: ContributionSettingApi[];
  taxBrackets: TaxBracketApi[];
  employeeDeductions: EmployeeDeductionApi[];
  dtrStatuses: EmployeeDtrStatusApi[];
  loading: boolean;
  error: string | null;
}

export const initialPayrollState: IPayrollState = {
  schedules: [],
  periods: [],
  runs: [],
  selectedRun: null,
  results: [],
  payslips: [],
  allowanceTypes: [],
  deductionTypes: [],
  contributionSettings: [],
  taxBrackets: [],
  employeeDeductions: [],
  dtrStatuses: [],
  loading: false,
  error: null,
};
